const blockHeroStandard = document.querySelector('.block-hero-standard');
const buttonWrapper = blockHeroStandard.querySelector('.wp-block-buttons');
const buttonList = blockHeroStandard.querySelectorAll('.wp-block-button:not(.is-style-tertiary)');

function setWidth() {
	for (let i = 0; i < buttonList.length; i++) {
		const button = buttonList[i];
		button.style.removeProperty('width');
	}

	if (buttonWrapper) {
		const buttonWrapperStyle = getComputedStyle(buttonWrapper);
		const buttonWrapperHeight = Math.ceil(buttonWrapperStyle.height.replace('px', ''));

		let widestButtonWidth = 0;
		let tallestButton = 0;

		for (let i = 0; i < buttonList.length; i++) {
			const button = buttonList[i];
			const buttonStyle = getComputedStyle(button);

			if (button.offsetWidth > widestButtonWidth) {
				widestButtonWidth = Math.ceil(buttonStyle.width.replace('px', ''));
			}

			if (button.offsetHeight > tallestButton) {
				tallestButton = Math.ceil(buttonStyle.height.replace('px', ''));
			}
		}

		if (buttonWrapperHeight > tallestButton) {
			for (let i = 0; i < buttonList.length; i++) {
				const button = buttonList[i];
				button.style.width = `${widestButtonWidth}px`;
			}
		}
	}
}

// GLOBAL APP CONTROLLER
const controller = {
	init() {},
	loaded() {
    setWidth();
  },
	resized() {
    setWidth();
  },
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;